import { render } from "./ProjectSwitcher.vue?vue&type=template&id=74a8dbb8"
import script from "./ProjectSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSwitcher.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74a8dbb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74a8dbb8', __exports__)) {
    api.reload('74a8dbb8', __exports__)
  }
  
  module.hot.accept("./ProjectSwitcher.vue?vue&type=template&id=74a8dbb8", () => {
    api.rerender('74a8dbb8', render)
  })

}


export default __exports__